import { jsonApi } from '@models/jsonApi';

jsonApi.define('privacy/cookie-scanner/setting/custom-field', {
  name: '',
  position: 1,
  is_system: 0,
  created: '',
  updated: '',
});
